import { useEffect, useState } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { useNavigate } from "fusion-plugin-react-router";
import { assetUrl } from "fusion-core";
import {
  TAXI_QUOTE_DISPLAY_IGNORE,
  TAXI_QUOTE_SOB,
} from "../../../config/config";
import QuoteStep from "../enums/QuoteStep";
import TqGetQuoteModal from "../components/tqGetQuoteModal";
import useQuoteStore from "../store/QuoteStore";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { toggleBodyScroll } from "../../../shared/utils/scrollUtils";
import { getUserIndicator } from "../../../shared/utils/userSessionUtils";

const css = assetUrl("../../../styles/tqStart.css");
const driverImage = assetUrl("../../../assets/images/tqStart-desktop.svg");
const icon = assetUrl("../../../assets/images/tqStart-icon.svg");

const TqStart = ({ setNextStep }) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
  const navigate = useNavigate();
  const indicator = getUserIndicator();

  const getSearchParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  };

  const setSearchParam = (param, value) => {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);

    urlParams.set(param, value);

    window.history.replaceState(
      {},
      "",
      `${url.pathname}?${urlParams.toString()}`
    );
  };

  const receivedCode = getSearchParam("code");

  const handleOpenModal = () => {
    setIsModalOpen(true); // Open the modal
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_NEW_QUOTE_CLICKED);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleClick = () => {
    setNextStep(QuoteStep.TQ1);
    setSearchParam("liveaccount", "NoLiveUberAccount");
    const { updateField } = useQuoteStore().getState();
    updateField("risk.riskObjectId", "1E4FB6C88CE14A5E921C34DA742F1893");
    updateField("risk.sourceOfBusinessId", TAXI_QUOTE_SOB);
  };

  const handleRetrieveClick = () => {
    navigate("/landing"); // Redirect to the login page
  };

  const handleUberClick = () => {
    window.open("https://www.uber.com/gb/en/drive/", "_blank");
  };

  useEffect(() => {
    if (receivedCode) {
      setNextStep(QuoteStep.TQ1);
    }
  }, [receivedCode, setNextStep]);

  useEffect(() => {
    toggleBodyScroll(isModalOpen);
    return () => {
      toggleBodyScroll(false);
    };
  }, [isModalOpen]);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={css} />
      </Helmet>

      <div>
        <div className="externalcontainer">
          <div className="containertqStart">
            <div className="textSection">
              <div>
                <img src={icon} alt="" className="margin-bottom-35" />
                <h1 className="heading">
                  Find tailored insurance coverage for your Uber.
                </h1>
                <div className="uberLink">
                  <a href="#" onClick={handleUberClick}>
                    If you're not a registered Uber driver then you'll be unable
                    to get a quote. Already have an Uber account then click 'Get
                    a New Quote.' and connect to your Uber account.
                  </a>
                </div>
                <div className="ButtonGetDiv">
                  <button
                    className="getQuoteButton"
                    onClick={handleOpenModal} // Open the modal on click
                  >
                    Get a New Quote
                  </button>
                  {indicator !== "NewCustomer" && (
                    <div className="signInText">
                      <a onClick={handleRetrieveClick}>
                        Retrieve Existing Quote
                      </a>
                    </div>
                  )}
                </div>
                {TAXI_QUOTE_DISPLAY_IGNORE && (
                  <p className="ignoreText">
                    <a onClick={handleClick} href="#">
                      Ignore
                    </a>
                  </p>
                )}
              </div>
            </div>
            <div className="imageSection">
              <img src={driverImage} alt="Driver" className="driverImage" />
            </div>
          </div>
        </div>
      </div>

      {/* Modal Component */}
      {isModalOpen && <TqGetQuoteModal onClose={handleCloseModal} />}
    </>
  );
};

export default TqStart;
